export const isInStock = (items: any[]) => {
  return items.some((item: any) => item.stock !== 'no');
};
